import React, {Component} from "react"
import {withRouter, RouteComponentProps} from "react-router-dom"
import {LandingContainer} from "../landing-container/landing-container";
import {Helmet} from "react-helmet";
import pasta from '../img/LABRA_Ai.png'
import "./ai.css"


interface AiProps extends RouteComponentProps {}

export class Ai extends Component<AiProps> {
    render() {
        return (
            <>
                <Helmet>
                    <title>LABRA AI - Платформа автоматического нормирования труда и хронометража операций | AI-аналитика в real-time</title>
                    <meta name="description" content="LABRA AI - платформа для автоматического нормирования труда и хронометража операций. Обучайте модели на ваших видео, анализируйте производительность в реальном времени с точностью 95%. Компьютерное зрение и AI-аналитика для оптимизации ручного труда."/>
                    <meta name="keywords" content="нормирование труда, хронометраж операций, фотохронометраж, AI анализ видео, производительность труда real-time, автоматическая аналитика, обучение моделей, компьютерное зрение, time and motion study, аналитика в real-time, стриминговая аналитика, мгновенные отчеты"/>

                    {/* Open Graph */}
                    <meta property="og:title" content="LABRA AI - Платформа автоматического нормирования труда и хронометража"/>
                    <meta property="og:description" content="Обучайте модели на ваших операциях, анализируйте производительность в real-time. Точность аналитики 95%."/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:url" content="https://www.labrahub.ru/#/ai"/>
                    <meta property="og:image" content="https://www.labrahub.ru/images/logos/LABRA_Ai.png"/>

                    {/* Twitter Card */}
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:title" content="LABRA AI - Платформа автоматического нормирования труда"/>
                    <meta name="twitter:description" content="Обучение моделей, хронометраж операций и AI-аналитика в real-time с точностью 95%"/>
                    <meta name="twitter:image" content="https://www.labrahub.ru/images/logos/LABRA_Ai.png"/>
                </Helmet>
                <LandingContainer titleText={"LABRA AI — Платформа автоматического нормирования и хронометража операций"} titleStyle={{'fontSize': 'xxx-large'}}>
                <div className="landing-section">
                    <div className="landing-section-content" style={{textAlign: 'center'}}>
                        <img src={pasta} style={{width: 400}}/>
                        <h3>Стриминговая аналитика: обучайте модели и получайте мгновенные отчеты в real-time</h3>
                        <p><b>AI-платформа для нормирования труда и хронометража операций</b> на основе компьютерного зрения.
                        Обучайте модели на ваших видео, анализируйте работу сотрудников в реальном времени
                        и получайте точные данные для оптимизации производительности. Точность аналитики — 95%.</p>
                        <div style={{ height: 10 }}/>
                        <p><a href={'/#/report-example'}>Пример</a> того, как данные могут выглядеть в отчете PDF (time and motion study)</p>
                    </div>
                </div>
            </LandingContainer>
            </>
        )
    };
}

export default withRouter(Ai)
